<template>
    <div class="post post-tiktok">
        <div class="detail-event-header no-border">
            <AvatarComponent :typeNetwork="page.network" :urlPicture="page.avatar" v-if="page"></AvatarComponent>

            <div class="info">
                <div class="namePage" v-if="page">
                    {{ page.name }}
                </div>
                <div class="typeEvent">
                    <p html>{{ dateFormatPost(event.date * 1000) }}</p>
                    <p v-if="postLink" class="show-post"><a :href="postLink" target="_blank">Voir</a></p>
                </div>
            </div>
            <div class="selectActionEvent">
                <SelectComponent :changeValueSelect="changeStatus" :data="{treated:$t('dash.inbox.state.treated'),waiting:$t('dash.inbox.state.waiting')}" :valueSelect="[1, 3].includes(event.status) ? 'treated' : 'waiting'" :positionY="'bottom'" :positionAuto="false"></SelectComponent>
            </div>
        </div>
        <div class="scrollable">
            <div class="container-content-post" v-if="item">
                <div class="content-post">
                    <div class="content">
                        <div class="picture loading-content" v-if="item.coverUrl">
                            <img :src="item.coverUrl">
                        </div>
                        <div class="text" v-if="item.desc"><pre>{{ item.desc }}</pre></div>
                    </div>
                    <div class="bar-action-container">
                        <div class="btns-action">
                            <div class="reaction">
                                <i class="fa-regular fa-heart"></i>
                                {{ getFormatNumber(item.likeCount || 0) }} j'aime
                            </div>
                            <div class="comments">
                                <i class="fa-regular fa-comment"></i>
                                {{ getFormatNumber(item.commentCount || 0) }} commentaire{{ item.commentCount > 1 ? 's' : '' }}
                            </div>
                            <div class="share">
                                <i class="fa-regular fa-share"></i>
                                {{ getFormatNumber(item.shareCount || 0) }} partage{{ item.shareCount > 1 ? 's' : '' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-content-comments" v-if="comment">
                <div class="container-comment" v-if="!deleted">
                    <div class="comment originalComment" :class="{'has-response': replies && replies.length}">
                        <div class="picture-user">
                            <img :src="comment.user && comment.user.avatar ? comment.user.avatar : 'img/avatar.jpg'">
                            <div class="lineStart" v-if="replies && replies.length"></div>
                        </div>
                        <div class="container-content">
                            <div class="content">
                                <p class="name-user">{{ comment.user ? (comment.user.name || comment.user.unique_id) : '' }}</p>
                                <p class="text">{{ comment.text }}</p>
                                <div class="media"></div>
                                <ContextMenu :options="getOptionComment()" :id="String(comment.commentId)" v-on:clickOption="clickOptionComment">
                                    <div class="btn-more"></div>
                                </ContextMenu>
                            </div>
                            <div class="info-content">
                                <div class="date">{{ dateFormat(comment.createTime * 1000) }}</div>
                                <div class="action">
                                    <div class="reaction" :class="{'have-liked': isLiked}" @click="toggleLike">J'aime{{ displayLikeCount ? ` (${getFormatNumber(displayLikeCount)})` : '' }}</div>
                                    <div class="answer" @click="autoFocus = true">Répondre</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="replies && replies.length">
                        <div v-for="(sub, index) in replies" :key="index" class="comment response" :class="{'end': index === replies.length - 1}">
                            <div class="jonction-line line-continuous"></div>
                            <div class="picture-user">
                                <img :src="sub.user && sub.user.avatar ? sub.user.avatar : 'img/avatar.jpg'">
                            </div>
                            <div class="container-content">
                                <div class="content">
                                    <p class="name-user">{{ sub.user ? (sub.user.name || sub.user.unique_id) : '' }}</p>
                                    <p class="text">{{ sub.text }}</p>
                                    <div class="media"></div>
                                    <ContextMenu :options="getOptionComment()" :id="String(sub.cid)" v-on:clickOption="clickOptionComment" v-if="sub.cid">
                                        <div class="btn-more"></div>
                                    </ContextMenu>
                                </div>
                                <div class="info-content">
                                    <div class="date">{{ dateFormat(sub.create_time * 1000) }}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <FormSendMessage v-on:onSubmitMessage="sendComment" :activeMedia="false" :setAutofocus="autoFocus" @autoFocused="autoFocus = false"></FormSendMessage>
    </div>
</template>

<script>
    import mixinModeration from './../../mixins/Moderation.vue'
    import ContextMenu from './../contextMenu/contextMenuInit.vue'
    import FormSendMessage from './FormSendMessage'
    import AvatarComponent from './../utils/avatar.vue'
    import SelectComponent from './../utils/select.vue'

    export default {
        name: 'component-post-tiktok',

        components: {
            FormSendMessage,
            ContextMenu,
            AvatarComponent,
            SelectComponent
        },

        mixins: [mixinModeration],

        props: {
            page: Object,
            event: Object,
            isLoading: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                autoFocus: false,
                liked: null,
                deleted: false,
                extraLikes: 0
            }
        },

        computed: {
            comment() {
                return this.event && this.event.data ? this.event.data.comment : null
            },
            item() {
                return this.event && this.event.data ? this.event.data.item : null
            },
            replies() {
                return this.event && this.event.data && this.event.data.replies ? this.event.data.replies : []
            },
            displayLikeCount() {
                return (this.comment && this.comment.likeCount ? this.comment.likeCount : 0) + this.extraLikes
            },
            isLiked() {
                return this.liked !== null ? this.liked : !!(this.comment && this.comment.hasCreatorLiked)
            },
            postLink() {
                if (!this.item || !this.item.itemId) return null
                const handle = this.page && this.page.name ? String(this.page.name).replace(/^@/, '') : 'user'
                return `https://www.tiktok.com/@${handle}/video/${this.item.itemId}`
            }
        },

        watch: {
            'comment.commentId'() {
                this.liked = null
                this.extraLikes = 0
                this.deleted = false
            }
        },

        methods: {
            changeStatus(status) {
                this.$emit('changeStatus', status)
            },

            // Une réponse supprimée peut être le sujet de son propre event dans l'inbox
            // (une autre notification, indépendante de celle affichée ici) : si on le trouve,
            // on le marque supprimé aussi plutôt que de le laisser trainer en attente.
            async markCommentEventDeleted(objectId) {
                try {
                    let res = await this.getInboxEvent(this.page.id, objectId)
                    if (res && res.body && res.body.event && res.body.event._id)
                        await this.postInboxEvent(res.body.event._id, this.page, { status: 4 })
                } catch (e) {
                    console.error('markCommentEventDeleted failed', e)
                }
            },

            getFormatNumber(number) {
                const absNumber = Math.abs(number)
                const fixed = value => value % 1 === 0 ? value.toFixed(0) : value.toFixed(1)
                if (absNumber >= 1e9) return fixed(number / 1e9) + ' MD'
                if (absNumber >= 1e6) return fixed(number / 1e6) + ' M'
                if (absNumber >= 1e3) return fixed(number / 1e3) + ' K'
                return number.toString()
            },

            dateFormat(dateComment) {
                if (typeof dateComment !== 'object') dateComment = new Date(dateComment)
                const date = new Date()
                const diff = Math.abs(date - dateComment)
                const min = Math.floor(diff / (1000 * 60))
                const hours = Math.floor(diff / (1000 * 60 * 60))
                const days = Math.floor(diff / (1000 * 60 * 60 * 24))
                const weeks = Math.floor(diff / (1000 * 60 * 60 * 24 * 7))
                const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365))
                if (years > 0) return years + (years === 1 ? ' an' : ' ans')
                if (weeks > 0) return weeks + 'sem'
                if (days > 0) return days + 'j'
                if (hours > 0) return hours + 'h'
                return min + 'min'
            },

            dateFormatPost(dateMessage) {
                if (typeof dateMessage !== 'object') dateMessage = new Date(dateMessage)
                const date = new Date()
                const tabMonth = ['Jan', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juill', 'Août', 'Sept', 'Oct', 'Nov', 'Déc']
                const minutes = (dateMessage.getMinutes() < 10 ? '0' : '') + dateMessage.getMinutes()
                if ((date.getDate() + '' + date.getMonth() + date.getFullYear()) == (dateMessage.getDate() + '' + dateMessage.getMonth() + dateMessage.getFullYear()))
                    return "Aujourd'hui à " + dateMessage.getHours() + ':' + minutes
                if (date.getFullYear() == dateMessage.getFullYear() && date.getMonth() == dateMessage.getMonth() && dateMessage.getDate() == date.getDate() - 1)
                    return 'Hier à ' + dateMessage.getHours() + ':' + minutes
                return 'Le ' + dateMessage.getDate() + ' ' + tabMonth[dateMessage.getMonth()] + ' ' + dateMessage.getFullYear() + ' à ' + dateMessage.getHours() + ':' + minutes
            },

            async toggleLike() {
                if (!this.comment) return
                const wasLiked = this.isLiked
                this.liked = !wasLiked
                this.extraLikes += wasLiked ? -1 : 1
                const res = await this.likeNode(this.page, this.comment.commentId, this.item ? this.item.itemId : null, wasLiked)
                if (!res.body || res.body.success !== true) {
                    this.liked = wasLiked
                    this.extraLikes += wasLiked ? 1 : -1
                }
            },

            getOptionComment() {
                return [{ label: this.$t('dash.button.delete'), name: 'deleteComment' }]
            },

            async clickOptionComment(id, nameOption) {
                if (nameOption !== 'deleteComment') return

                if (this.comment && String(id) === String(this.comment.commentId)) {
                    this.deleted = true
                    const res = await this.deleteNode(this.page, this.comment.commentId)
                    if (!res.body || res.body.success !== true) {
                        this.deleted = false
                        return
                    }
                    this.$emit('deleteComment', this.event._id)
                    return
                }

                const reply = this.replies.find(r => String(r.cid) === String(id))
                if (reply) {
                    const res = await this.deleteNode(this.page, reply.cid)
                    if (res.body && res.body.success === true) {
                        this.event.data.replies = this.replies.filter(r => r !== reply)
                        this.markCommentEventDeleted(`comment-${reply.cid}`)
                    }
                }
            },

            async sendComment(formData) {
                const message = formData.get('message')
                if (!message) return
                const optimistic = {
                    cid: '',
                    text: message,
                    create_time: Math.round(Date.now() / 1000),
                    user: { name: this.page.name }
                }
                this.event.data.replies = [...this.replies, optimistic]
                const res = await this.addComment(this.page, this.comment.commentId, message, this.item ? this.item.itemId : null)
                if (!res.body || res.body.success !== true) {
                    this.event.data.replies = this.replies.filter(r => r !== optimistic)
                }
            }
        }
    }
</script>
